import React from 'react';
import { MdOutlineDinnerDining } from "react-icons/md";
import { LuTrees } from "react-icons/lu";
import { TbBuildingCastle } from "react-icons/tb";
import { MdPool } from "react-icons/md";
import { GiDesert } from "react-icons/gi";
import './Facilities.css';

const FacilitiesBanquet = () => {
  const sections = [
    {
      title: "Spacious Banquet Halls",
      text: "Elegant, well-decorated banquet halls with customizable seating arrangements, perfect for weddings, receptions, and corporate events.",
      icon: <TbBuildingCastle size={120}/>,
      list: [
        "Luxurious rooms and suites with modern amenities.",
        "Room service and housekeeping.",
        "Complimentary breakfast options.",
        "Private balconies with scenic views."
      ],
      bgClass: "choice-based",
    },
    {
      title: "Lush Green Lawns & Gardens",
      text: "Beautifully landscaped gardens for outdoor ceremonies and receptions, offering a serene and picturesque setting for memorable events.",
      icon: <LuTrees size={120}/>,
      list: [
        "Expansive green lawns ideal for outdoor weddings and receptions.",
        "Beautifully landscaped gardens perfect for photo shoots and gatherings..",
        "Customizable décor setups for themed events and ceremonies.",
        "Well-maintained spaces with ambient lighting for evening events."
      ],
      bgClass: "programs-tailored",
    },
    {
      title: "Swimming Pool with Lounge Area",
      text: "A luxurious swimming pool with a relaxing lounge area, ideal for poolside parties, pre-wedding shoots, and leisure activities.",
      icon: <MdPool size={120}/>,
      list: [
        "Spacious pool area perfect for poolside parties and pre-wedding celebrations.",
        "Comfortable lounge chairs and shaded cabanas for relaxation.",
        "Professional lifeguard services ensuring guest safety.",
        "Poolside décor and lighting for evening events."
      ],
      bgClass: "project-based",
    },
    {
      title: "Catering & Dining Services",
      text: "Professional catering with a variety of cuisine options, including buffet setups and personalized menu selections for all types of events.",
      icon: <MdOutlineDinnerDining size={120}/>,
      list: [
        "Multi-cuisine menu with customizable options for events.",
        "Live food counters and buffet setups for large gatherings.",
        "Professional chefs and staff ensuring quality service.",
        "Themed dining experiences for special occasions.",
      ],
      bgClass: "mooc",
    },
    {
      title: "Lake view and Desert view",
      text: "Enjoy breathtaking lake views, serene surroundings, fresh air, and the soothing sound of water all in one perfect escape. Whether you're relaxing by the shore, taking a leisurely stroll, or simply soaking in the beauty, the lake offers a peaceful retreat like no other.",
      icon: <GiDesert size={120} />,
      list: [
        "Panoramic views of the serene lake",
        "Tranquil environment perfect for relaxation.",
        "Refreshing breeze and natural beauty.",
        "Ideal spot for leisurely walks and outdoor activities.",
      ],
      bgClass: "lake",
    }
    
  ];

  return (
    <div className="academics-overview-container-main1">
    <div className="academics-overview-container">

      {sections.map((section, index) => (
        <div
          key={index}
          className={`academics-overview-section ${section.bgClass} ${index % 2 !== 0 ? 'reverse-order' : ''}`}
        >
          <div className="academics-overview-icon">{section.icon}</div>
          <div className="academics-overview-content">
            <h2 className="academics-overview-title">{section.title}</h2>
            <p className="academics-overview-text">{section.text}</p>
            <ul className="academics-overview-list">
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default FacilitiesBanquet;
